<template>
    <div class="c-blog__filters__checkbox__field" :class="[modifiers, {'is-focused':focused}]" v-if="id && title">
        <span class="c-blog__filters__checkbox__heading" v-if="heading">{{ heading }}</span>
        <label :class="{'c-blog__filters__checkbox__all':heading}">
            <input ref="input" 
                :id="id" 
                :name="id" 
                type="checkbox" 
                value="1" 
                :aria-label="$t('blog.category.aria') + ' ' + title" 
                :checked="checked"
                @focus="focused=true" 
                @blur="focused=false" 
                @change="(event) => $emit('update:checked', event.target.checked)"
                :tabindex="tabindex"
            >
            <span>{{ title }}</span>
            <Checkmark />
        </label>
    </div>
</template>

<script>
    import Checkmark from './icons/Checkmark.vue';

    export default {
        name: 'CheckboxField',
        components: {
            Checkmark
        },
        props: {
            id: {
                type: String,
                default: '',
            },
            heading: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            modifiers: {
                type: String,
                default: '',
            },
            checked: {
                type: Boolean,
                default: false,
            },
            state: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                focused: false,
            }
        },
        mounted() {},
        computed: {
            tabindex() {
                return (this.state) ? '' : '-1';
            }
        },
        methods: {}
    }
</script>